export { VpNoMediaCollected } from './VpNoMediaCollected';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpNoMediaCollected/index.js